import styled from 'styled-components';
import {Layout} from 'antd';

const {Content} = Layout;

export const StyledMainContentView = styled(Content)<{$fullBleed?: boolean}>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${({$fullBleed}) => ($fullBleed ? '0' : '20px 20px 0')};
  min-height: auto !important;
  //background-color: ${({theme}) => theme.palette.background.default};

  @media screen and (min-width: ${({theme}) => theme.breakpoints.md}px) {
    padding: ${({$fullBleed}) => ($fullBleed ? '0' : '30px 32px 0')};
    &.bureau {
      padding: ${({$fullBleed}) => ($fullBleed ? '0' : '30px 0 0')};
    }
  }
`;
